import React, {useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserAuth } from "../../context/AuthContext";
import logo from "../../logo-no-background.png"
const SignIn = () => {
  let navigate = useNavigate();
  let [error, setError] = useState("");
  let emailRef = useRef();
  let passwordRef = useRef();
  let { currentUser, login } = UserAuth();
  let handleSignIn = async () => {
    await login(emailRef.current.value, passwordRef.current.value)
      .then(()  => {
        if(emailRef.current.value == "feng.xiao@pomona.edu" || emailRef.current.value=="Feng.Xiao@pomona.edu" || emailRef.current.value=="captest2023@gmail.com" || emailRef.current.value == "junaid@techsembly.com" || emailRef.current.value == "asyalyubavina03@gmail.com"){
          navigate("/Admin")
        }
        else
        navigate("/quiz");
      })
      .catch((error) => setError(error?.message));
  };  
  useEffect(() => {
  if (currentUser) {
    navigate("/quiz")
  }
  }); 
  return (
        <div className="wrapper position-relative">
          <div className="header">
            <a className="logo" href={void(0)}>
              {/* <img width="150" src={logo} alt="" /> */}
              Adaptive Chinese Placement Test
            </a>
            <a className="right-content" href={void(0)} onClick={() => navigate("/about")}>About</a>
          </div>
          <div className="container">
            {error && <h3>{error}</h3>}
              <div className="multisteps_form position-relative overflow-hidden" id="wizard">
                <div className="row">
                    <div className="col-md-12">
                      <div className="form_header_content text-center pt-4">
                          <h2>Login</h2>
                          <div className="auth-form">
                          <input className="my-input" type="email" ref={emailRef} placeholder="Email"/>
                          <input className="my-input" type="password" ref={passwordRef} placeholder="Password" />
                          <a style={{textDecoration:"underline", color: "blue", textAlign:"right"}} onClick={() => navigate("/forgot-password")}>Forgot Password?</a>
                          <button style={{alignSelf:"center"}} className="theme-btn" onClick={() => handleSignIn()}> Sign In </button>
                          <a style={{textDecoration:"underline", color: "blue"}} onClick={() => navigate("/signup")}>New User? Sign Up Here</a>
                        </div>
                      </div>
                      </div>
                    </div>
                </div>
          </div>
        </div>
  );
};

export default SignIn;
